import React from 'react';
import styles from '../../builder.module.scss';

export const BuilderInfoSquareComponent = ({ data }) => (
  <div className={`${styles.builderInfoSquare} builderInfoSquare`}>{data}</div>
);
